import React from 'react'
import moment from 'moment'

export const dateFormatter = (cell, row, rowIndex, formatExtraData) => {
  return (
    <span>
      {moment(row[formatExtraData]).format('LLLL')}
    </span>
  )
}